<template>
  <div>
    <base-page-heading
      :title="templateTitle"
      show-back-button
    />
    <div class="content">
      <b-row>
        <b-col>
          <quote-templates-form
            v-if="loaded"
            v-bind="template"
            :new-form="false"
            @on-submit="updateTemplate"
            @on-save="onSave"
            @on-cancel="onCancel"
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import QuoteTemplatesForm from '@/components/admin/quoteTemplates/Form.vue';

export default {
  name: 'QuoteTemplatesEdit',
  components: {
    QuoteTemplatesForm,
  },
  data() {
    return {
      template: null,
      loaded: false,
    };
  },
  computed: {
    templateTitle() {
      return this.template?.name ? `Edit ${this.template.name}` : 'Edit Quote Template';
    },
  },
  mounted() {
    this.loadTemplate();
  },
  methods: {
    loadTemplate() {
      this.$quoteTemplatesAPI
        .get(this.$route.params.id)
        .then((template) => {
          this.template = template;
        })
        .catch(() => {
          this.$router.push('/404');
        })
        .finally(() => {
          this.loaded = true;
        });
    },
    updateTemplate(data, handleUpdate) {
      handleUpdate(this.$quoteTemplatesAPI.update(this.$route.params.id, data));
    },
    onSave() {
      this.$router.push({ name: 'quote-templates' });
    },
    onCancel() {
      this.$router.push({ name: 'quote-templates' });
    },
  },
};
</script>
